
import ResearchEquipmentRepositoryAPI from "@/modules/research-equipment/research-equipment-repository-api";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import { defineComponent, watch, inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "AddToCompare",
  props: {
    id: {
      type: String,
      default: null,
    },
    item: {} as any,
  },
  setup(props) {
    const compare = ref(false);
    const toast: any = inject("toast");
    const { t } = useI18n();
    const router = useRouter();
    const { getAuth } = UserRepositoryAPI();
    const { addToCompare, removeFromCompare } =
      ResearchEquipmentRepositoryAPI();

    watch(compare, (currentValue) => {
      if (currentValue) {
        addToCompare(props.item);
        toast.add({
          severity: "success",
          summary: "Dodano v primerjalnik",
          detail: "",
          life: 1000,
        });
      } else {
        removeFromCompare(props.item);
        toast.add({
          severity: "warn",
          summary: "Odstranjeno iz primerjalnika",
          detail: "",
          life: 1000,
        });
      }
    });

    const goToComparisons = (): void => {
      const isAuthenticated = getAuth.value.isAuthenticated as boolean;
      if (!isAuthenticated) {
        toast.add({
          severity: "warn",
          summary: "Prijava",
          detail: "Za primerjavo opreme mora biti uporabnik prijavljen",
          life: 3000,
        });
        return;
      }
      router.push({
        name: "user-comparisons",
        params: { id: getAuth.value.uuid },
      });
    };

    return {
      t,
      compare,
      goToComparisons,
    };
  },
});
